
import {Component, Mixins, Prop} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {AlacakliOlduguDosyaTalep} from "@/interface/IUyapTalep";
import BorcluIcraDosyasiPicker from "@/components/pickers/uyap/BorcluIcraDosyasiPicker.vue";
import {IIcraDosyasiSonuc} from "@/plugins/uyap-plugin/uyap/BorcluIcraDosyasi";

@Component({
  components: {BorcluIcraDosyasiPicker}
})
export default class AlacakliOlduguDosyaTalepEvrakForm extends Mixins(ObjectInputMixin) {
  @Prop() dosyaId!: number;
  @Prop() kisiKurumId!: number;

  localValue!: AlacakliOlduguDosyaTalep;

  // Sorgu cevabındaki alan adları guncelKisiKurumId / dosyaTurKodu. Eskiden kisiKurumId ve
  // dosyaTurKod okunuyordu; ikisi de undefined olduğu için JSON.stringify bu alanları tamamen
  // atıyor, UYAP'a eksik talep gidiyordu. Ölü BorcluIcraDosyasiCevapRow tipi @ts-ignore ile
  // import edildiğinden TS de uyarmıyordu. (DEV-1131)
  onDosyaChange(data: IIcraDosyasiSonuc) {
    this.localValue.kisiKurumId = data.guncelKisiKurumId;
    this.localValue.birimAdi = data.birimAdi;
    this.localValue.dosyaNo = data.dosyaNo;
    this.localValue.dosyaTurKod = data.dosyaTurKodu;
    this.input();
  }
}
